module.exports = __webpack_public_path__ + "img/no2.a356987.png";